import React from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import './styles.css'; // Import the CSS file
import ApiService from '../../classes/ApiService';
import { toast } from "react-toastify";

const GoogleSigninButton = ({ onSuccess, onError, onNonOAuthError, text, type, register }) => {

    const ToastContent = ({ header, body }) => (
        <div>
            <strong style={{ fontSize: "16px" }}>{header}</strong>
            <p style={{ margin: "5px 0 0" }}>{body}</p>
        </div>
    );

    const handleGoogleLogin = async (credentialResponse) => {
        const apiService = new ApiService();

        // Show loading toast
        const toastId = toast.loading(`${register ? "Registering"  : "Signing in"} with Google...`, { ariaLabel: `${register ? "Registering"  : "Signing in"} with Google`});

        try {
            const path = register ? "/registration/google-register" :  "/registration/google-login";                               
            const response = await apiService.post(path, {
                token: credentialResponse.access_token,
                type,
                app: 'web'
            });

            // Update toast on success
            toast.update(toastId, {
                render: `Google ${register ? "registration"  : "login"} successful!`,
                type: "success",
                isLoading: false,
                autoClose: 5000,
                closeButton: true,
            });

            if (onSuccess) {
                onSuccess(response);
            }else{
                if (response.success === true) {
                    //If all went well, send them to the core application
                    window.location.href = response.data.url;
                } else {
                    // Update toast on error
                    toast.update(toastId, {
                        render: <ToastContent header={`Google ${register ? "registration"  : "login"} Error!`} body={`Google ${register ? "registration"  : "login"} failed due to ${response.message}. Please try again.`} />,
                        type: "error",
                        isLoading: false,
                        autoClose: 5000,
                        closeButton: true,
                    });

                    if (onError) {
                        onError(response);
                    }
                }
            }
        } catch (error) {
            console.error(error);

            // Update toast on error
            toast.update(toastId, {
                render: <ToastContent header={`Google ${register ? "registration"  : "login"} Error!`} body={`Google ${register ? "registration"  : "login"} failed due to ${error.message}. Please try again.`} />,
                type: "error",
                isLoading: false,
                autoClose: 5000,
                closeButton: true,
            });

            if (onError) {
                onError(error);
            }
        }
    };

    const login = useGoogleLogin({
        type: "standard",
        theme: "outline",
        logo_alignment: "center",
        cancel_on_tap_outside: true,
        ux_mode: "popup",
        context: "signup",
        onSuccess: (codeResponse) => onSuccess ? onSuccess(codeResponse) : handleGoogleLogin(codeResponse),
        onError: (codeResponse) => {
            const toastId = toast.loading(`${register ? "Registering"  : "Signing in"} with Google...`, { ariaLabel: `${register ? "Registering"  : "Signing in"} with Google`});
            const errorMessage = codeResponse.message || `An error occurred during Google ${register ? "registration"  : "login"}.`;

            // Update toast on non-OAuth error
            toast.update(toastId, {
                render: <ToastContent header={`Google ${register ? "registration"  : "login"} Error!`} body={errorMessage} />,
                type: "error",
                isLoading: false,
                autoClose: 5000,
                closeButton: true,
            });

            if (onError) {
                onError(codeResponse);
            }
        },
        onNonOAuthError: (codeResponse) => {
            const toastId = toast.loading(`${register ? "Registering"  : "Signing in"} with Google...`, { ariaLabel: `${register ? "Registering"  : "Signing in"} with Google`});
            const errorMessage = codeResponse.message || "An error occurred during Google login.";

            // Update toast on non-OAuth error
            toast.update(toastId, {
                render: <ToastContent header={`Google ${register ? "registration"  : "login"} Error!`} body={errorMessage} />,
                type: "error",
                isLoading: false,
                autoClose: 5000,
                closeButton: true,
            });

            if (onNonOAuthError) {
                onNonOAuthError(codeResponse);
            }
        },
        flow: "implicit",
    });

    return (
        <div onClick={() => login()} className="google-signin-btn" style={{ textAlign: "center" }}>
            <img width="16px" height="16px" src="/img/google_icon.svg" alt="Google Icon" />
            <span>{text || `${register ? "Continue"  : "Sign in"} with Google`}</span>
        </div>
    );
};

export default GoogleSigninButton;
